import { get, post } from '@/utils/request'

export function getConfig(type) {
  return get(`/fixed-data/config/${type}`)
}

export function updateConfig(data) {
  return post('manage/fixed-data/config/update', data)
}
